// Hidden SVG sprite: referenced across the page with <use href="#crown"/> etc.
export default function SvgSymbols() {
  return (
    <svg width="0" height="0" style={{ position: 'absolute' }} aria-hidden="true">
      <defs>
        <filter id="spray" x="-20%" y="-20%" width="140%" height="140%">
          <feTurbulence type="fractalNoise" baseFrequency="1.2" numOctaves="2" result="n" />
          <feDisplacementMap in="SourceGraphic" in2="n" scale="5" />
        </filter>
      </defs>
      <symbol id="crown" viewBox="0 0 100 80">
        <path d="M12 64 L8 20 L32 44 L50 8 L68 44 L92 20 L88 64 Z" fill="none" stroke="currentColor" strokeWidth="7" strokeLinejoin="round" strokeLinecap="round" />
        <path d="M14 72 Q50 66 86 72" fill="none" stroke="currentColor" strokeWidth="6" strokeLinecap="round" />
        <circle cx="8" cy="15" r="5" fill="currentColor" /><circle cx="50" cy="5" r="5" fill="currentColor" /><circle cx="92" cy="15" r="5" fill="currentColor" />
        <path d="M30 72 v8 M66 72 v6" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
      </symbol>
      <symbol id="sparkle" viewBox="0 0 100 100">
        <path d="M50 0C54 36 64 46 100 50 64 54 54 64 50 100 46 64 36 54 0 50 36 46 46 36 50 0Z" fill="currentColor" />
      </symbol>
      <symbol id="die" viewBox="0 0 100 100">
        <g stroke="#ff8ef0" strokeWidth="2.6" strokeLinejoin="round">
          <path d="M50 6 92 27 50 48 8 27Z" fill="#ff3d8f" />
          <path d="M8 27 50 48 50 94 8 73Z" fill="#a50d4e" />
          <path d="M50 48 92 27 92 73 50 94Z" fill="#d3166a" />
        </g>
        <g fill="#fff">
          <ellipse cx="50" cy="27" rx="7" ry="3.8" />
          <ellipse cx="20" cy="45" rx="3.6" ry="5.2" transform="rotate(-25 20 45)" />
          <ellipse cx="38" cy="76" rx="3.6" ry="5.2" transform="rotate(-25 38 76)" />
          <ellipse cx="62" cy="76" rx="3.6" ry="5.2" transform="rotate(25 62 76)" />
          <ellipse cx="71" cy="61" rx="3.6" ry="5.2" transform="rotate(25 71 61)" />
          <ellipse cx="80" cy="46" rx="3.6" ry="5.2" transform="rotate(25 80 46)" />
        </g>
      </symbol>
      <symbol id="chip" viewBox="0 0 100 100">
        <circle cx="50" cy="50" r="47" style={{ fill: 'var(--c1,#f5b400)' }} stroke="#000" strokeOpacity=".35" strokeWidth="2" />
        <circle cx="50" cy="50" r="40" fill="none" stroke="#fff" strokeWidth="11" strokeDasharray="14 17.4" />
        <circle cx="50" cy="50" r="27" style={{ fill: 'var(--c2,#ffd84a)' }} stroke="#fff" strokeWidth="2.5" strokeDasharray="4 3" />
        <path d="M37 58 35 42 43 50 50 38 57 50 65 42 63 58Z" fill="#fff" />
      </symbol>
      <symbol id="bill" viewBox="0 0 160 70">
        <rect x="1" y="1" width="158" height="68" rx="4" fill="#c7e2b5" stroke="#3d6b45" strokeWidth="2" />
        <rect x="8" y="7" width="144" height="56" rx="3" fill="none" stroke="#5a8a5f" strokeWidth="2" />
        <ellipse cx="80" cy="35" rx="20" ry="24" fill="#9cc391" stroke="#3d6b45" strokeWidth="2" />
        <circle cx="80" cy="30" r="8" fill="#5a8a5f" /><path d="M66 52q14-14 28 0" fill="#5a8a5f" />
        <g fontFamily="Montserrat,sans-serif" fontWeight="900" fill="#2f5a36">
          <text x="14" y="26" fontSize="16">100</text><text x="122" y="60" fontSize="16">100</text><text x="128" y="28" fontSize="20">$</text>
        </g>
      </symbol>
    </svg>
  );
}
